import React from 'react';
import { connect } from 'react-redux';
import { Form, Errors, actions } from 'react-redux-form';
import range from 'lodash/range';
import get from 'lodash/get';
import moment from 'moment';

import { MAX_CONTRACT_SIZE } from '../../shared/const';

import formStyles from '../form/Form.css';

import person from './person';
import TextField from '../form/TextField';
import CheckboxField from '../form/CheckboxField';
import FormError from '../form/FormError';
import PersonField from './PersonField';
import PriceField from './PriceField';

import cgu from 'file?name=[name].pdf!../resources/CGU.pdf';

const { WH_API_URL } = process.env;

function testUnique(identifier, contractNumber, done) {
  if (identifier === '' || contractNumber === '') {
    done(true);
    return;
  }

  fetch(`${WH_API_URL}contract?identifier=${identifier}&contractNumber=${contractNumber}`)
    .then(
      res => done(res.status === 404),
      () => done(true)
    );
}

class UniqueContractNumberFieldDumb extends React.Component {
  render() {
    const { model, identifier, contractNumber } = this.props;

    return (
      <div className={formStyles.row}>
        <TextField
          model={`${model}.identifier`}
          label="Identifiant"
          asyncValidators={{
            isUnique: (v, done) => {
              testUnique(identifier, contractNumber, done);
            },
          }}
          messages={{
            isUnique: 'Un contrat avec ce numéro existe déjà.',
          }}
          required
        />

        <TextField
          model={`${model}.contractNumber`}
          label="N° de contrat"
          asyncValidators={{
            isUnique: (v, done) => {
              testUnique(identifier, contractNumber, done);
            },
          }}
          messages={{
            isUnique: 'Un contrat avec ce numéro existe déjà.',
          }}
          required
        />
      </div>
    );
  }
}

const UniqueContractNumberField = connect((state, props) => ({
  identifier: get(state, props.model).identifier,
  contractNumber: get(state, props.model).contractNumber,
}))(UniqueContractNumberFieldDumb);

class ActForm extends React.Component {
  onSubmit = act => {
    const { valid } = this.props;

    if (valid) {
      this.props.onSubmit(act);
    }
  }

  onAddClient = () => {
    const { dispatch, model } = this.props;
    dispatch(actions.push(`${model}.clients[]`, person.natural));
  }

  onRemoveClient = i => {
    const { dispatch, model } = this.props;
    dispatch(actions.remove(`${model}.clients[]`, i));
  }

  render() {
    const { model, clientsCount } = this.props;

    return (
      <Form
        className={formStyles.form}
        model={model}
        onSubmit={this.onSubmit}
        validators={{
          '': {
            partiesAreMajor: ({ date, author, clients }) =>
              [author]
                .concat(clients)
                .filter(p => p.kind === 'natural')
                .every(p => moment(date).diff(p.birthdate, 'years') >= 18),
            mustAcceptConditions: ({ acceptsEULA }) => acceptsEULA,
          },
        }}
      >
        <UniqueContractNumberField model={model} />

        <div className={formStyles.inputColumns}>
          <div className={formStyles.inputColumn}>
            <div className={formStyles.title}>
              Vous / Votre société
            </div>

            <PersonField
              model={`${model}.author`}
              isAuthor
            />
          </div>

          {range(clientsCount).map(i =>
            <div
              key={i}
              className={formStyles.inputColumn}
            >
              <PersonField
                id={i}
                title={`Client N°${i + 1}`}
                onRemove={i !== 0 && this.onRemoveClient}
                model={`act.clients[${i}]`}
              />
            </div>
          )}
        </div>

        <button
          type="button"
          className={formStyles.bigButton}
          onClick={this.onAddClient}
        >
          Ajouter une autre partie
        </button>

        <div className={formStyles.bigTitle}>
          Votre <strong>contrat</strong>
        </div>

        <div className={formStyles.inputColumns}>
          <div className={formStyles.inputColumn}>
            <div className={formStyles.title}>
              Votre contrat
            </div>

            <TextField
              inputProps={{ type: 'date' }}
              model={`${model}.date`}
              label="Date de votre contrat"
              required
            />

            <PriceField
              model={`${model}.contractValue`}
              label="Valeur du contrat (€)"
              required
            />
          </div>

          <div className={formStyles.inputColumn}>
            <div className={formStyles.title}>
              Documents justificatifs
            </div>

            <TextField
              inputProps={{
                type: 'file',
                accept: '.pdf',
              }}
              model={`${model}.contractFile`}
              label="Votre contrat signé (PDF)"
              validators={{
                contractSize: v => !v || !v.length || v[0].size <= MAX_CONTRACT_SIZE,
                isPDF: v => !v || !v.length || v[0].type === 'application/pdf',
              }}
              messages={{
                contractSize: 'La taille de votre contrat ne doit pas dépasser 24Mo.',
                isPDF: 'Le fichier du contrat signé doit être au format PDF.',
              }}
              required
            />
          </div>

        </div>

        <CheckboxField
          model={`${model}.acceptsEULA`}
          label={
            <span>
              J'accepte les <a href={cgu}>CGU du service</a> et demande
              la mise en place immédiate de la prestation.
            </span>
          }
        />

        <Errors
          model={model}
          className={formStyles.formError}
          show={form =>
            form.submitFailed || form.errors && form.errors.serverError
          }
          messages={{
            partiesAreMajor: (
              'Toutes les parties personnes physiques du contrat doivent ' +
              'être majeures à la date du contrat.'
            ),
            mustAcceptConditions: (
              'Vous devez accepter les conditions générales d\'utilisation ' +
              'du service avant de continuer.'
            ),
            serverError: (
              'Une erreur est survenue pendant le traitement de votre requête.'
            ),
          }}
          component={FormError}
        />

        <button
          className={formStyles.submitButton}
          type="submit"
        >
          Envoyer
        </button>
      </Form>
    );
  }
}

export default connect((state, props) => ({
  clientsCount: get(state, props.model).clients.length,
  valid: get(state, props.form).valid,
}))(ActForm);



/** WEBPACK FOOTER **
 ** ./client/act/ActForm.js
 **/